export const previewswitchActions = {
    changePreview,
}

function changePreview(preview){
    return dispatch => {
        dispatch({ type: preview });
    }
}